import { Box, Flex, IconButton, Image, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Tooltip, useToast } from "@chakra-ui/react";
import FAIcon from "@components/FAIcon";
import { useFirebase } from "context/firebase.context";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";

const SubscriptionSummary = ({ creatorId }) => {
  const { firestore } = useFirebase();
  const [subscriptions, setSubscriptions] = useState([]);
  const toast = useToast();

  useEffect(() => {
    const subQuery = query(
      collection(firestore, "creator-subscriptions"),
      where("creatorId", "==", creatorId),
      where("currentPeriodEnd", ">=", Date.now())
    );
    const subUnsubscribe = onSnapshot(subQuery, (snapshot) => {
      setSubscriptions(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return subUnsubscribe;
  }, [creatorId, firestore]);


  const activeSubs = useMemo(() => subscriptions.filter((sub) => sub.status === "active"), [subscriptions]);

  const renderTable = (subs) => (
    subs.map(sub => (
      <Flex key={sub.id} alignItems="center" p={2} borderBottom="1px" borderColor="gray.200">
        <Image src={`https://stream-cdn.nightco.io/users/${sub.user.userId}/picture_512.webp`} boxSize="40px" borderRadius="full" mr={2} fallbackSrc="https://via.placeholder.com/40" />
        {sub.user?.displayName || 'Unknown'}
        <IconButton
          size="sm"
          ml={2}
          icon={<FAIcon name="copy" />}
          onClick={() => {
            navigator.clipboard.writeText(sub.user.userId);
            toast({ title: "User ID copied", status: "success", duration: 2000 });
          }}
          aria-label="Copy User ID"
        />
        <Text ml={4}>${sub.subscribedPrice}</Text>
        {sub.cancelAtPeriodEnd ? (
          <Tooltip label={`${sub.cancelReason}`} hasArrow>
            <Text
              ml={4}
              color="yellow.500"
            >
              到期結束
            </Text>
          </Tooltip>
        ) : (
          <Text
            ml={4}
            color={sub.status === "active" ? "green.500" : "gray.500"}
          >
            {sub.status}
          </Text>
        )}
        <Text ml={4}>{sub.currentPeriodStart ? new Date(sub.currentPeriodStart).toLocaleDateString() : 'N/A'}</Text>
        <Text ml={4}>{sub.currentPeriodEnd ? new Date(sub.currentPeriodEnd).toLocaleDateString() : 'N/A'}</Text>
      </Flex>
    ))
  );

  return (
    <Box p={4}>
      <Text fontWeight="bold" mb={2}>活躍訂閱用戶 {activeSubs.length} 人</Text>
      <Tabs variant="enclosed" mt={2}>
        <TabList>
          <Tab>活躍訂閱</Tab>
          <Tab>所有訂閱</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            {renderTable(activeSubs)}
          </TabPanel>
          <TabPanel>
            {renderTable(subscriptions)}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default SubscriptionSummary;
